<template>
    <div class="page-wrapper" :style="{ height:'760px', backgroundImage:`url(${Bg})` }">
        <div class="page-content" style="padding-top:80px; ">
            <div class="title" style="color:#fff; margin-bottom:60px; color:#000; "><span style="color:#2d52ff">200+</span>用户 <span style="color:#2d52ff">2W+</span>终端的连接案例</div>
            <div class="box-container">
                <div
                    v-for="item in list"
                    :key="item.key"
                    class="box-wrapper"
                >
                    <img v-if="!item.empty" :src="item.img" style="width:100%; height:100%;" />

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Bg from '@/assets/customer-icons/customer-bg.png';
    import Bg1 from '@/assets/customer-icons/customer-icon-1.png';
    import Bg2 from '@/assets/customer-icons/customer-icon-2.png';
    import Bg3 from '@/assets/customer-icons/customer-icon-3.png';
    import Bg4 from '@/assets/customer-icons/customer-icon-4.png';
    import Bg5 from '@/assets/customer-icons/customer-icon-5.png';
    import Bg6 from '@/assets/customer-icons/customer-icon-6.png';
    import Bg7 from '@/assets/customer-icons/customer-icon-7.png';
    import Bg8 from '@/assets/customer-icons/customer-icon-8.png';
    import Bg9 from '@/assets/customer-icons/customer-icon-9.png';
    import Bg10 from '@/assets/customer-icons/customer-icon-10.png';
    import Bg11 from '@/assets/customer-icons/customer-icon-11.png';
    import Bg12 from '@/assets/customer-icons/customer-icon-12.png';
    import Bg13 from '@/assets/customer-icons/customer-icon-13.png';
    import Bg14 from '@/assets/customer-icons/customer-icon-14.png';
    import Bg15 from '@/assets/customer-icons/customer-icon-15.png';
    import Bg16 from '@/assets/customer-icons/customer-icon-16.png';
    import Bg17 from '@/assets/customer-icons/customer-icon-17.png';
    import Bg18 from '@/assets/customer-icons/customer-icon-18.png';
    import Bg19 from '@/assets/customer-icons/customer-icon-19.png';
    import Bg20 from '@/assets/customer-icons/customer-icon-20.png';
    import Bg21 from '@/assets/customer-icons/customer-icon-21.png';
    import Bg22 from '@/assets/customer-icons/customer-icon-22.png';
    import Bg23 from '@/assets/customer-icons/customer-icon-23.png';
    import Bg24 from '@/assets/customer-icons/customer-icon-24.png';
    const list = [
        { key:'1', img:Bg1 }, { key:'2', img:Bg2 }, { key:'3', img:Bg3 }, { key:'4', img:Bg4 }, { key:'5', img:Bg5 },
        { key:'6', img:Bg6 }, { key:'7', img:Bg7 }, { key:'8', img:Bg8 }, { key:'9', img:Bg9 }, { key:'10', img:Bg10 }, { key:'11', img:Bg11 }, { key:'12', img:Bg12 },
        { key:'13', img:Bg13 }, { key:'14', img:Bg14 }, { key:'15', img:Bg15 }, { key:'16', img:Bg16 }, { key:'17', img:Bg17 }, { key:'18', img:Bg18 }, { key:'19', img:Bg19 }, 
        { key:'20', img:Bg20 }, { key:'21', img:Bg21 }, { key:'22', img:Bg22 }, { key:'23', img:Bg23 }, { key:'24', img:Bg24 },
    ];
    export default {
        data(){
            return {
                Bg,
                list
            }
        }
    }
    
    
</script>

<style>
    .box-container {
        display:flex; 
        justify-content: center; 
        flex-wrap:wrap; 
        gap:1.71rem; 
    }
    .box-container .box-wrapper {
        width:11.4rem;
        height:5.7rem;
    }
    .box-container .box-wrapper > img {
        /* border-radius:8px; */
        transition:all 0.15s ease-out;
    }
    .box-container .box-wrapper > img:hover {
        /* border:6px solid transparent; */
        transform:scale(1.2);
        box-shadow:0 0 50px #0000000d;
    }
</style>